import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {ReferenceService} from '../../../apiModule1';
import {Observable} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {map} from 'rxjs/operators';

@Component({
  selector: 'pas-status-select',
  standalone: true,
  imports: [
    MatIcon,
    AsyncPipe,
    MatDialogModule
  ],
  templateUrl: './status-select.component.html',
  styleUrl: './status-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusSelectComponent implements OnInit {
  readonly referenceService = inject(ReferenceService);
  readonly dialogRef = inject(MatDialogRef<StatusSelectComponent>);
  readonly data = inject(MAT_DIALOG_DATA);

  statuses$: Observable<GradeStatus[]> | null = null;

  ngOnInit(): void {
    console.log('data', this.data);
    this.statuses$ = this.referenceService.apiReferenceGradestatusesGet()
      .pipe(map((v: { values: GradeStatus[]})=>v.values));
  }
}
